import { z } from 'zod';

// Messages de validation zod en français (formulaires côté client).
z.config(z.locales.fr());
